import React from 'react';
import { FormattedMessage } from 'react-intl';

import Box from '@quintoandar/cozy-core/Box';
import Button from '@quintoandar/cozy-core/Button';
import Typography from '@quintoandar/cozy-core/Typography';
import Grid from '@quintoandar/cozy-core/Grid';

import { useTrackEvent } from 'Base/Tracking/hooks/useTrackEvent';
import { ERROR_PAGE_IMAGE_URL } from 'config';
import ROUTES from 'routes/constants';
import messages from './messages';

const goToHome = () => {
  window.location.href = ROUTES.BASE_PATH;
};

const ErrorContainer = () => {
  const trackEvent = useTrackEvent();
  trackEvent({
    event: 'error_page_viewed',
    extraProperties: {
      type: 'error',
    },
  });

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      width="100%"
    >
      <Grid container justify="center" spacing={3}>
        <Grid item lg={5} md={5} sm={5} xs={12}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
          >
            <Box
              component="img"
              src={ERROR_PAGE_IMAGE_URL}
              display="block"
              width="100%"
              maxWidth={500}
              height="auto"
            />
          </Box>
        </Grid>
        <Grid item lg={5} md={5} sm={5} xs={12}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            width="100%"
            maxWidth={500}
            mx="auto"
            px={3}
          >
            <Typography level="title" mb={2}>
              <FormattedMessage {...messages.errorHeader} />
            </Typography>
            <Typography level="body" mb={4}>
              <FormattedMessage {...messages.errorDescription} />
            </Typography>
            <Button
              fullWidth
              onClick={goToHome}
              data-testid="back-to-home-button"
              variant="contained"
              color="primary"
              size="large"
            >
              <FormattedMessage {...messages.back} />
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ErrorContainer;
